package com.neurobs.ccabserver.administrator.components

import com.neurobs.ccabserver.administrator.contexts.MenuState.MenuItemType
import com.neurobs.ccabserver.administrator.contexts.{MenuContext, TestStationContext}
import com.neurobs.js.dom.ElementFactory
import com.neurobs.react.{GapSize, HoriAlign, HtmlAdapter, LTFullRow, LayoutTable}
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.core.facade.Hooks.useEffect
import slinky.web.html.{className, div}

@react object ExaminerSet {
	type Props = Unit

	val component = FunctionalComponent[Props] { _ =>
		val context = TestStationContext.accessState()
		val menu = MenuContext.accessState()

		useEffect(() =>
			if (menu.value.alerts.contains(MenuItemType.Examiner) != context.data.examiners.nonEmpty) {
				menu.setExaminerStatus(on = context.data.examiners.nonEmpty)
			}
		)
		div(className := "nfw-scrollbox")(
			LayoutTable(gapSize = GapSize.Medium, fullWidth = true)(
				context.data.examiners map { e =>
					e.onClose = () => {
						context.removeExaminer(e)
					}
					LTFullRow(align = HoriAlign.Left)(
						HtmlAdapter(element = ElementFactory.toElement(e.container))
					).withKey(e.sessionInfo.sessionId)
				}
			)
		)
	}
}
